//国搜排行榜.
function Rolling_news() {
	var topics = {};
	jQuery.Topic = function (id) {
		var callbacks,
			topic = id && topics[id];
		if (!topic) {
			callbacks = jQuery.Callbacks();
			topic = {
				publish: callbacks.fire,
				subscribe: callbacks.add,
				unsubscribe: callbacks.remove
			};
			if (id) {
				topics[id] = topic;
			}
		}
		return topic;
	};
	if(typeof(Rolling_news_right) != "undefined"){
		_rendermain(Rolling_news_right);
	}else{
		return false;	
	}
	
	function _rendermain(res) {
		
					var tpl = '';
					var newUrl = '';
					for(i=0;i<res.length;i++){
						newUrl = res[i].url ? res[i].url : ('http://www.chinaso.com/search/pagesearch.htm?q='+res[i].word);
			
						tpl += '<a target="_blank" href="'+newUrl+'">'+res[i].word+'</a>'
					}
					$('#chinaso_keyword_ul').html(tpl);
				}
			
}

 Rolling_news();
 


//////////////////
// WEBPACK FOOTER
// ./static/v4/js/Rolling_news_right.js
// module id = b363883eb902a3b89d2d
// module chunks = 1